import { UseAppSelector, UseAppDispatch } from '../store/hooks';
import { resetStats, initDashboard } from '../store/statsEngine';

// Reset statsEngine defaults and dispatch business specific data attributes
function CalculatorInit(currentReducer) {
    const dispatch = UseAppDispatch();

    // grabs redux store slice
    const data = UseAppSelector(state => {
        if(currentReducer === 'arcade') {
            return state.arcade;
        } else if(currentReducer === 'nightclub') {
            return state.nightclub;
        } else if(currentReducer === 'bunker') {
            return state.bunker;
        } else if(currentReducer === 'lockup') {
            return state.lockup;
        } else if(currentReducer === 'lab') {
            return state.lab;
        } else if(currentReducer === 'forgery') {
            return state.forgery;
        } else if(currentReducer === 'farm') {
            return state.farm;
        } else if(currentReducer === 'counterfeit') {
            return state.counterfeit;
        }
        return null;
    })

    // redux
    const defaults = data.find(item => item.title === 'no-upgrade');
    const reducer = data.find(item => item.title === 'current-reducer');

    // reducers
    dispatch(resetStats({}));
    dispatch(initDashboard(
        {
            defaults: defaults,
            reducer: reducer,
            data: data
        }
    ));
}

export default CalculatorInit;